let cacheMap = new Map();
let cacheDurationMs = 5 * 60 * 1000; // 5 minutes TTL
let maxEntries = 200; // Maximum cache capacity
const CLEANUP_INTERVAL = 2 * 60 * 1000; // 2 minutes cleaning interval
let lastCleanup = Date.now();
const generateKey = (userId) => {
    return `profile:${userId}`;
};
const isExpired = (cachedItem) => {
    return Date.now() > cachedItem.expiresAt;
};
const removeExpired = () => {
    const now = Date.now();
    for (const [key, value] of cacheMap.entries()) {
        if (now > value.expiresAt) {
            cacheMap.delete(key);
        }
    }
};
const removeOldest = () => {
    if (cacheMap.size >= maxEntries) {
        const entriesToRemove = Math.floor(maxEntries * 0.1);
        const entries = Array.from(cacheMap.entries())
            .sort((a, b) => a[1].expiresAt - b[1].expiresAt)
            .slice(0, entriesToRemove);
        entries.forEach(([key]) => cacheMap.delete(key));
    }
};
// Periodic cleanup check
const periodicCleanup = () => {
    const now = Date.now();
    if (now - lastCleanup > CLEANUP_INTERVAL) {
        removeExpired();
        lastCleanup = now;
    }
};
const setCachedProfile = (userId, profileData) => {
    if (!userId.trim())
        return;
    periodicCleanup();
    removeOldest();
    const key = generateKey(userId);
    const cachedProfile = {
        data: profileData,
        expiresAt: Date.now() + cacheDurationMs,
    };
    cacheMap.set(key, cachedProfile);
};
const getCachedProfile = (userId) => {
    if (!userId.trim())
        return null;
    const key = generateKey(userId);
    const cachedItem = cacheMap.get(key);
    if (!cachedItem) {
        return null;
    }
    if (isExpired(cachedItem)) {
        cacheMap.delete(key);
        return null;
    }
    return cachedItem.data;
};
const invalidateCachedProfile = (userId) => {
    if (!userId.trim())
        return;
    const key = generateKey(userId);
    cacheMap.delete(key);
};
const clearCache = () => {
    cacheMap.clear();
    lastCleanup = Date.now();
};
let profileCacheInstance = null;
export const getProfileCache = () => {
    if (!profileCacheInstance) {
        profileCacheInstance = {
            set: setCachedProfile,
            get: getCachedProfile,
            invalidate: invalidateCachedProfile,
            clear: clearCache,
        };
    }
    return profileCacheInstance;
};
export const resetProfileCache = () => {
    profileCacheInstance = null;
    cacheMap.clear();
    lastCleanup = Date.now();
};
